import {
    parcoursFormaliteBasePath,
    parcoursFormaliteClientsStepPath,
    parcoursFormaliteDocsStepPath,
    parcoursFormaliteFormaliteStepPath,
    parcoursFormaliteFormStepPath,
    parcoursFormaliteNextFormStepPath,
    parcoursFormaliteRecapStepPath,
    type ParcoursFormaliteSupportedView,
} from './constants';

export const parcoursFormalitePathResolver = function (
    view: ParcoursFormaliteSupportedView,
    prestaIndex: number = 0,
    formPage: number = 0,
): string {
    switch (view) {
        case 'stepFormalite':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteFormaliteStepPath].join('/');
        case 'stepClient':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteClientsStepPath].join('/');
        case 'stepForm':
            return [
                '',
                parcoursFormaliteBasePath,
                parcoursFormaliteFormStepPath,
                prestaIndex,
                formPage,
            ].join('/');
        case 'stepDocs':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteDocsStepPath].join('/');
        case 'stepRecap':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteRecapStepPath].join('/');
        case 'stepNextForm':
            return [
                '',
                parcoursFormaliteBasePath,
                parcoursFormaliteNextFormStepPath,
                prestaIndex,
                formPage,
            ].join('/');
        default:
            throw new Error(`${view} routing not implemented`);
    }
};
